"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ApiInjector_1 = __importDefault(require("../lib/ApiInjector"));
const endpoints_1 = require("./endpoints");
class VoxeetApi {
    static getToken() {
        return VoxeetApi.accessToken;
    }
    static setToken(token) {
        VoxeetApi.accessToken = token;
    }
    static setAccessTokenExpiration(expiration) {
        VoxeetApi.accessTokenExpiration = expiration;
    }
    static getJwtToken() {
        return VoxeetApi.jwtToken;
    }
    static getTokenCallback() {
        return VoxeetApi.tokenCallback;
    }
    static getHost() {
        return VoxeetApi.host;
    }
    static getAccessTokenExpiration() {
        return VoxeetApi.accessTokenExpiration;
    }
    static getLeavingCallback() {
        return VoxeetApi.leavingCallback;
    }
    static isTokenExpired() {
        return VoxeetApi.accessTokenExpiration - new Date().getTime() / 1000 < 0;
    }
    static setRegion(region) {
        if (region && region.length === 2 && this.flavor !== 'devssl') {
            VoxeetApi.host = `https://${this.flavor === 'staging' ? 'staging-' : ''}go-${region}.voxeet.com`;
            VoxeetApi.wsHost = `wss://${this.flavor === 'staging' ? 'staging-' : ''}go-${region}.voxeet.com/v2/session`;
        }
        else {
            VoxeetApi.host = __HOST__;
            VoxeetApi.wsHost = __WS_HOST__;
        }
    }
    // CAT feature related method
    static getCurrentConferenceToken() {
        return VoxeetApi.currentConferenceToken;
    }
    static setCurrentConferenceToken(conferenceId) {
        VoxeetApi.currentConferenceToken = VoxeetApi.conferenceTokens.get(conferenceId);
    }
    static getConferenceToken(conferenceId) {
        return VoxeetApi.conferenceTokens.get(conferenceId);
    }
    static setConferenceTokens(conferenceId, conferenceToken) {
        VoxeetApi.conferenceTokens = VoxeetApi.conferenceTokens.set(conferenceId, conferenceToken);
    }
    static clearConferenceTokens() {
        VoxeetApi.conferenceTokens.clear();
    }
}
// A Map of conferenceId (key) and conferenceToken (value)
VoxeetApi.conferenceTokens = new Map();
VoxeetApi.host = __HOST__;
VoxeetApi.wsHost = __WS_HOST__;
VoxeetApi.flavor = __FLAVOR__;
ApiInjector_1.default.inject(VoxeetApi, VoxeetApi.getToken, VoxeetApi.setToken, VoxeetApi.getJwtToken, VoxeetApi.getTokenCallback, VoxeetApi.getCurrentConferenceToken, VoxeetApi.getHost, endpoints_1.endpoints, true, VoxeetApi.isTokenExpired, VoxeetApi.getLeavingCallback);
exports.default = VoxeetApi;
